import type { GetPostSummaryQuery } from '../../gql/graphql';
import { formatScore } from '../../helpers/scoreDisplay';
import './PostSummaryCard.scss';

export interface PostSummaryCardProps {
  summary: NonNullable<GetPostSummaryQuery['getPostSummary']>;
}

export const PostSummaryCard = ({ summary }: PostSummaryCardProps) => {
  const { title, teaser, author, score, readTime, categories } = summary;

  return (
    <div className="post-summary-card">
      <h1 className="post-summary-card__title">{title}</h1>
      {teaser && <p className="post-summary-card__teaser">{teaser}</p>}

      <div className="post-summary-card__meta">
        {author?.username && (
          <span className="post-summary-card__author">
            by {author.username}
          </span>
        )}
        <span className="post-summary-card__score">
          Score: {formatScore(score)}
        </span>
        {typeof readTime === 'number' && (
          <span className="post-summary-card__read-time">
            {readTime} min read
          </span>
        )}
      </div>

      {categories && categories.length > 0 && (
        <div className="post-summary-card__categories">
          {categories.map(
            (category) =>
              category && (
                <span key={category} className="chip">
                  {category}
                </span>
              ),
          )}
        </div>
      )}
    </div>
  );
};
